/**
 * Keeps the iOS app icon badge in sync with unread notifications + messages.
 */

import { useEffect } from 'react';
import { useNotificationCount } from '../../utils/NotificationCountContext';
import { useMessageCount } from '../../utils/MessageCountContext';
import { setAppIconBadge } from '../../helpers/appBadgeHelpers';

function AppIconBadgeBridge() {
  const { unreadCount } = useNotificationCount();
  const { unreadMessageCount } = useMessageCount();

  useEffect(() => {
    setAppIconBadge((unreadCount || 0) + (unreadMessageCount || 0));
  }, [unreadCount, unreadMessageCount]);

  return null;
}

export default AppIconBadgeBridge;
